export const r2 = (n) => Math.round((Number(n) || 0) * 100) / 100;
// Ürünün EN SON alındığı fatura (occurrences en yeniden eskiye sıralı gelir)
export const pickOcc = (g) => (g.occurrences || [])[0] || null;
export const occKey = (o) => `${o.incoming_id}:${o.index}`;
export const trUp = (s) => String(s || "").toLocaleUpperCase("tr-TR");
export const defaultQty = (o) => (o.quantity < 1 ? o.quantity : 1);
